<template>
  <div>
    <el-card>
      <el-table :data="tableData"
                border
                style="width: 100%;margin-bottom: 20px;margin-top: 20px"
                height="500px"
      >
        <el-table-column label="#" type="index" />
        <el-table-column prop="instanceName" label="流程名称">
        </el-table-column>
        <el-table-column prop="startTime" label="开始时间">
          <template v-slot="scope">
            {{ $filters.dateFilter(scope.row.startTime)  }}
          </template>
        </el-table-column>
        <el-table-column prop="endTime" label="结束时间">
          <template v-slot="scope">
            {{ $filters.dateFilter(scope.row.endTime)  }}
          </template>
        </el-table-column>
        <el-table-column prop="initiator" label="发起人">
        </el-table-column>
        <el-table-column prop="node" label="当前审批节点">
          <template v-slot="scope">
            <el-tag v-if="scope.row.node !== ''" type="success" size="large">{{ scope.row.node }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isEnd" label="审批状态">
          <template v-slot="scope">
            <el-tag v-if="scope.row.isEnd" type="success">结束</el-tag>
            <el-tag v-else type="warning">审批中...</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
        >
          <template #default="{ row }">
            <el-button type="primary" size="small" @click="handleCheckInfo(row)">查看审批信息</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
  <m-dialog v-model="checkInfoDialog" :show-sure="false">
    <el-descriptions
      title="合同明细查看"
      direction="vertical"
      :column="4"
      size="default"
      border
    >
      <el-descriptions-item label="合同名称" :span="2">{{ checkContractInfo.contractName }}</el-descriptions-item>
      <el-descriptions-item label="授信额度" :span="2" class-name="my-content">{{ checkContractInfo.creditLimit }}</el-descriptions-item>
      <el-descriptions-item label="合同金额类型" :span="2">{{ checkContractInfo.contractMoneyType === 1 ? '非框架合同' : '框架合同' }}</el-descriptions-item>
      <el-descriptions-item label="合同金额" :span="2">{{ checkContractInfo.contractMoney }}</el-descriptions-item>
      <el-descriptions-item label="合同开始时间" :span="2">{{ $filters.dateFilter(checkContractInfo.contractStartTime) }}</el-descriptions-item>
      <el-descriptions-item label="合同结束时间" :span="2">{{ $filters.dateFilter(checkContractInfo.contractEndTime) }}</el-descriptions-item>
      <el-descriptions-item label="结算方式" :span="2">{{ checkContractInfo.balanceStyle === 1 ? '预付款' : (checkContractInfo.balanceStyle === 2 ? '充值账期' : '消耗账期') }}</el-descriptions-item>
      <el-descriptions-item label="结算周期" :span="2">{{ checkContractInfo.balanceTime === 1 ? '三日结' : (checkContractInfo.balanceStyle === 2 ? '周结' : '月结') }}</el-descriptions-item>
      <el-descriptions-item label="返点(%)" :span="2">{{ checkContractInfo.rebate }}</el-descriptions-item>
      <el-descriptions-item label="补充返点(%)" :span="2">{{ checkContractInfo.supplyRebate }}</el-descriptions-item>
    </el-descriptions>
  </m-dialog>
</template>
<script setup>

import { getInstancesByUserName } from '@/api/his'
import { ref } from 'vue'
import MDialog from '@/components/MDialog/index.vue'
import { getContractInfoById } from '@/api/formal'

const checkInfoDialog = ref(false)
const tableData = ref([])
const getHisInstances = async () => {
  const result = await getInstancesByUserName()
  console.log(JSON.stringify(result))
  tableData.value = result
}

getHisInstances()

const checkContractInfo = ref([])
const handleCheckInfo = async (row) => {
  checkContractInfo.value = await getContractInfoById({
    contractId: row.businessKey
  })
  if (!checkInfoDialog.value) {
    checkInfoDialog.value = true
  }
}

</script>
